/** /faq/ 独立 FAQ 页 */
export const faqPageMeta = {
	title: 'GB WhatsApp Pro FAQ – Common Questions Answered',
	description:
		'Answers to common GB WhatsApp Pro questions about privacy, updates, safety, file sharing, and account restrictions. Independent help, not official WhatsApp support.',
	keywords: 'gb whatsapp pro faq, gb whatsapp pro questions, gb whatsapp pro help',
}

export const faqIntro = {
	lead:
		'These answers are short by design. When you need ordered troubleshooting steps, open the <a href="/help/">help center</a>. For long-form risk and how-to articles, browse the <a href="/blog/">blog</a>.',
	note:
		'GB WhatsApp Pro is unofficial software. We are not WhatsApp LLC or Meta. Nothing here guarantees account safety or feature availability on your APK build.',
}

/** 分组展示；首页仍用扁平 faqItems */
export const faqGroups = [
	{
		id: 'basics',
		title: 'Basics & features',
		items: [
			{
				question: 'Is GB WhatsApp Pro the same as official WhatsApp?',
				answer:
					'No. GB WhatsApp Pro is a modified Android application distributed outside Google Play. It is not developed or supported by WhatsApp LLC or Meta. Feature menus and version numbers differ from the official app.',
			},
			{
				question: 'Can I hide my online status with GB WhatsApp Pro?',
				answer:
					'Many modified builds include extra privacy toggles, such as hiding online status or read receipts. Options vary by version, and they do not remove all visibility risks. See <a href="/features/privacy-features/">privacy features</a> and <a href="/safety/privacy-risks/">privacy risks</a>.',
			},
			{
				question: 'Can I use GB WhatsApp Pro on iPhone?',
				answer:
					'GB WhatsApp Pro is built for Android APK installation. There is no official iOS version; sites offering “GB WhatsApp IPA” files are often misleading or unsafe.',
			},
			{
				question: 'What Android version do I need?',
				answer:
					'Our current verified build lists Android 5.0+ as the minimum. Some features may require newer Android versions. Check Settings → About phone before sideloading large APKs.',
			},
			{
				question: 'How do I know which version I have installed?',
				answer:
					'Open in-app Settings → App info or Help (wording varies) and compare with <a href="/update/check-version/">check your version</a> and the label on <a href="/download/">download</a>.',
			},
		],
	},
	{
		id: 'install',
		title: 'Install, update & backup',
		items: [
			{
				question: 'How do I update GB WhatsApp Pro?',
				answer:
					'Updates are usually manual: download a newer APK, back up chats first, then install over the existing app or reinstall if Android requires it. Follow the <a href="/update/">update guide</a> and <a href="/update/without-losing-chats/">update without losing chats</a>.',
			},
			{
				question: 'Why will GB WhatsApp Pro not install on my phone?',
				answer:
					'Common causes include low storage, an incompatible Android version, a corrupted download, or Play Protect blocking unknown sources. Start with <a href="/help/not-installing/">not installing help</a> and <a href="/installation/android/">Android installation</a>.',
			},
			{
				question: 'Do I need to back up chats before installing or updating?',
				answer:
					'Yes, whenever you change versions or reinstall. Local data can be lost if installation fails or if you must uninstall first. See <a href="/installation/backup-chats/">chat backup guidance</a> and <a href="/installation/restore-chats/">restore chats</a>.',
			},
			{
				question: 'Can I run GB WhatsApp Pro and official WhatsApp together?',
				answer:
					'Some APKs use a different package name for dual install, but one phone number usually registers on one client at a time. Read <a href="/installation/without-uninstalling/">install without uninstalling</a> before assuming dual-app mode works.',
			},
		],
	},
	{
		id: 'safety',
		title: 'Safety & account restrictions',
		items: [
			{
				question: 'Will using GB WhatsApp Pro guarantee that my account will not be restricted?',
				answer:
					'No third-party mod can guarantee that. WhatsApp may apply restrictions to accounts that use unofficial clients. Treat any “anti-ban” claim as marketing, not a promise. Read <a href="/will-gb-whatsapp-get-you-banned/">ban risk explainer</a>.',
			},
			{
				question: 'Is it safe to download GB WhatsApp Pro from any website?',
				answer:
					'Unknown APK sources can host altered or malicious files. Compare file size with our <a href="/download/">download page</a> and read <a href="/safety/malware-and-fake-apks/">malware and fake APK guide</a> before installing.',
			},
			{
				question: 'What should I do if WhatsApp says I must use the official app?',
				answer:
					'That is a restriction signal from WhatsApp, not GBWhatPro.org. Stop using the mod, install official WhatsApp, and restore from backup if possible. See <a href="/switch-from-gb-whatsapp-to-official-whatsapp/">switching to official WhatsApp</a>.',
			},
		],
	},
	{
		id: 'troubleshooting',
		title: 'Troubleshooting',
		items: [
			{
				question: 'Why did my verification SMS not arrive?',
				answer:
					'Carrier delays, roaming, wrong country code, or too many code requests can block SMS. Follow <a href="/help/verification-code-not-received/">verification code help</a>. Never share codes with strangers.',
			},
			{
				question: 'Why do messages show one grey tick forever?',
				answer:
					'That usually means the message has not left your phone—check network, VPN, and background restrictions. See <a href="/help/messages-not-sending/">messages not sending</a>.',
			},
			{
				question: 'Why are notifications delayed or missing?',
				answer:
					'Android battery savers, disabled notification channels, and mod DND features can delay alerts. Start with <a href="/help/notifications-not-working/">notifications not working</a> and <a href="/help/messages-not-receiving/">messages not receiving</a>.',
			},
		],
	},
	{
		id: 'site',
		title: 'About GBWhatPro.org',
		items: [
			{
				question: 'Does GBWhatPro.org provide customer support for my account?',
				answer:
					'No. We publish guides only. For site corrections or privacy questions about GBWhatPro.org, use <a href="/contact/">contact</a>. We cannot reset bans or send verification codes.',
			},
		],
	},
]

export const faqItems = faqGroups.reduce((acc, group) => acc.concat(group.items), [])
